/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
/* Package JSON Import will be here */

/* Project Import will be here */
import PreviousWeekTimeCardComponent from './previousWeekTimeCard.Component';
import { ApiUrls } from '../../../services/api';
import * as moment from 'moment';
import Api from '../../../services/api/serviceCall';
import { Constants } from '../../../config/appConstants';
import { MessageBox } from '../../../scenes/sharedComponent/messageBox';
import { isEqual } from 'lodash';
import * as actions from '../../../actions/tmVoucher.Action';
import { bindActionCreators } from 'redux';
import { EmptyAttestDetails, getAttestation } from '../Attestation/AttestationUtils';
import { replaceNullWithEmptyString } from '../../../services/utility';
/* Project Import will be here */

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class PreviousWeekTimeCard extends Component {
    constructor(props) {
        super(props);
        var beforeOneWeek = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000)
        var day = beforeOneWeek.getDay()
        var diffToMonday = beforeOneWeek.getDate() - day + (day === 0 ? -6 : 1)
        var lastMonday = new Date(beforeOneWeek.setDate(diffToMonday))
        var lastSunday = new Date(lastMonday.getTime() + 6 * 24 * 60 * 60 * 1000);
        this.state = {
            weekStartDate: lastMonday,
            weekEndingDate: lastSunday,
            isIssueNotesModalVisible: false,
            issueNotesList: [],
            selectedAttachment: "",
            isAttachmentModelVisible: false,
            timeRecords: [],
            selectedPayrollNote: "",
            isShowPunchesModal: false,
            isShowPayrollNoteModal: false,
            isShowActualNoteModal: false,
            isShowExpectationNoteModal: false,
            isOpenActualNotes: false,
            selectedActualNote: {},
            selectedTimeCardPunches: {},
            selectedExpectationNote: {},
            isShowLoader: false,
            fromDate: '',
            toDate: '',
            isShowTMVoucher: this.props.tmVoucherReducer.setTmVoucherModelVisibility ?? false,
            tmTaskCodeList: [],
            selectedTMVoucher: {},
            tmVoucherConfirmMessage: '',
            isAllowAttestation: false,
        }
    }

    componentWillMount() {
        window.addEventListener('beforeunload', () => {
            this.props.setTmVoucherModelVisibility(false);
        });
        this.getTimeCardData();
        this.getTMVoucherTaskCodes();
    }

    getTimeCardData() {
        let { weekStartDate, weekEndingDate, timeRecords } = this.state;

        var startTime = new Date(weekStartDate.setHours(0, 0, 0));
        var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        var tomorrow = new Date(weekEndingDate);
        var endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        var endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        var timeZone = startDate.toString();
        var selectTimeZone = timeZone.slice(16, 24);

        var selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        var selectedDate = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
        var fromDate = `${selectDate} ${selectTimeZone}`;
        var toDate = `${selectedDate} ${selectTimeZone}`;

        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_TME_CRD_DTE_RNG}?fromDate=${fromDate}&toDate=${toDate}&deviceId=${this.props.device.deviceId}&isSubmittedOnly=${true}`;
        Api.Get(url, this).then(responseData => {
            if (responseData.success) {
                this.setState({ isAllowAttestation: responseData.data.isAllowAttestation });
                var timeRecordData = responseData.data.timecardList;

                var groupByEmployee = timeRecordData.reduce((prev, curr) => {
                    if (curr.employeeID) {
                        var previousData = prev.find(a => a.employeeID == curr.employeeID);
                        if (prev && previousData) {
                            previousData.timecardData = [...previousData.timecardData || [], curr];
                            previousData.totalStHours = Number(previousData.totalStHours) + Number(curr.stHours ? curr.stHours : 0);
                            previousData.totalOtHours = Number(previousData.totalOtHours) + Number(curr.otHours ? curr.otHours : 0);
                            previousData.totalDtHours = Number(previousData.totalDtHours) + Number(curr.dtHours ? curr.dtHours : 0);
                            previousData.timeRecordIds = [...previousData.timeRecordIds || [], curr.timeRecordID];
                        }
                        else {
                            prev.push({
                                employeeName: curr.fullName,
                                employeeID: curr.employeeID,
                                employeeNumber: curr.employeeNumber,
                                timeRecordIds: [curr.timeRecordID],
                                date: moment(curr.createdDate).format('MM/DD/YYYY'),
                                timecardData: [curr],
                                totalStHours: Number(curr.stHours ? curr.stHours : 0),
                                totalOtHours: Number(curr.otHours ? curr.otHours : 0),
                                totalDtHours: Number(curr.dtHours ? curr.dtHours : 0)
                            });
                        }
                        return prev;
                    }
                    else {
                        prev = [];
                        return prev;
                    }
                }, []);
                timeRecords.sort((a, b) => new Date(...a.date.split('/').reverse()) - new Date(...b.date.split('/').reverse()));
                this.setState({
                    timeRecords: groupByEmployee,
                    fromDate: fromDate,
                    toDate: toDate
                });
            }
        });
    }

    closeIssueNotes(issue) {
        this.setState({
            isIssueNotesModalVisible: false
        })
    }

    openOrClosePunchesModal = notes => {
        let { selectedTimeCardPunches } = this.state;
        if (notes.isShowPunchesModal) {
            selectedTimeCardPunches = {
                startTime: replaceNullWithEmptyString(notes.selectedTimeCardPunches.startTime),
                lunchStartTime: replaceNullWithEmptyString(notes.selectedTimeCardPunches.lunchStartTime),
                lunchEndTime: replaceNullWithEmptyString(notes.selectedTimeCardPunches.lunchEndTime),
                endTime: replaceNullWithEmptyString(notes.selectedTimeCardPunches.endTime),
            }
            this.setState({ isShowPunchesModal: notes.isShowPunchesModal, selectedTimeCardPunches });
        } else {
            this.setState({ isShowPunchesModal: false, selectedTimeCardPunches: {} });
        }
    }

    openOrCloseExpectationNoteModel = notes => {
        let { timeRecords, selectedExpectationNote } = this.state;
        let selectedNote;
        if (notes.modalOpenExceptationalNote) {
            selectedNote = timeRecords[notes.rowIndex].timecardData[notes.empIndex];
            selectedExpectationNote = {
                expectationUnits: selectedNote.expectationUnits,
                expectationNote: selectedNote.expectationNote
            }
            this.setState({
                isShowExpectationNoteModal: notes.modalOpenExceptationalNote, selectedExpectationNote
            });
        }
        else {
            this.setState({ isShowExpectationNoteModal: false, selectedExpectationNote: {} });
        }
    }

    openOrClosePayrollNoteModel = notes => {
        let { timeRecords, selectedPayrollNote } = this.state;
        let selectedNote;
        if (notes.modalOpenPayRollNote) {
            selectedNote = timeRecords[notes.rowIndex].timecardData[notes.empIndex];
            selectedPayrollNote = selectedNote.payrollNote;
            this.setState({
                isShowPayrollNoteModal: notes.modalOpenPayRollNote, selectedPayrollNote
            });
        }
        else {
            this.setState({ isShowPayrollNoteModal: false, selectedPayrollNote: "" });
        }
    }

    openNotes = notes => {
        let { timeRecords, selectedActualNote } = this.state;
        let selectedNote = timeRecords[notes.rowIndex].timecardData[notes.empIndex];
        if (notes.modalOpenActualNote) {
            let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ATCHMT_BY_TMC_ID_M}?timeRecordId=${selectedNote.timeRecordID}&deviceId=${this.props.device.deviceId}`;
            Api.Get(url, this, true, true).then(response => {
                if (response.success) {
                    let attachmentLists = [];
                    if (response.data.length > 0) {
                        response.data.map((attach) => {
                            attachmentLists.push({
                                id: attach.id,
                                attachmentType: attach.attachmentType,
                                attachmentName: attach.attachmentName,
                                attachmentContent: attach.attachmentContent
                            });
                        });
                    }
                    selectedActualNote = {
                        timeRecordID: notes.timeCardId,
                        deviceID: notes.deviceId,
                        actualUnits: selectedNote && selectedNote.workUnits ? selectedNote.workUnits : '',
                        actualNote: selectedNote && selectedNote.workNote ? selectedNote.workNote : '',
                        attachments: attachmentLists
                    }
                    this.setState({
                        isOpenActualNotes: notes.modalOpenActualNote, selectedActualNote, isShowLoader: false
                    });
                }
                else {
                    this.setState({ isOpenActualNotes: false, selectedActualNote: {}, isShowLoader: false });
                }
            });

        }
    }

    onClickActualNoteBack() {
        this.setState({
            isOpenActualNotes: false
        })
    }

    onClickBack() {
        this.props.history.goBack();
    }

    openAttachmentViewer(attachment) {
        this.setState({
            isAttachmentModelVisible: true,
            selectedAttachment: attachment
        });
    }

    closeAttachmentViewer() {
        this.setState({
            isAttachmentModelVisible: false,
            selectedAttachment: ""
        });
    }

    getTimeCardIssue() {
        let { weekStartDate, weekEndingDate } = this.state;

        var startTime = new Date(weekStartDate.setHours(0, 0, 0));
        var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        var tomorrow = new Date(weekEndingDate);
        var endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        var endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        var selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        var selectedDate = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
        var timeZone = startDate.toString();
        var selectTimeZone = timeZone.slice(16, 24);
        var fromDate = `${selectDate} ${selectTimeZone}`;
        var toDate = `${selectedDate} ${selectTimeZone}`;


        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ISE_NT_M}?fromDate=${fromDate}&toDate=${toDate}&deviceId=${this.props.device.deviceId}&isSubmittedOnly=${true}`;
        Api.Get(url, this).then(responseData => {
            if (responseData.success) {
                this.setState({
                    isIssueNotesModalVisible: true, issueNotesList: responseData.data
                });
            } else {
                MessageBox(responseData.message, Constants.ERROR);
            }
        });
    }

    onClickDailyDetails = () => {
        let { fromDate, toDate } = this.state;
        this.props.history.push('DailyDetails', { fromDate: fromDate, toDate: toDate, isAllowToEdit: false, isNewStatus: true });
    }

    onClickTMVoucherBtn() {
        this.props.setTmVoucherModelVisibility(true);
        this.setState({ isShowTMVoucher: true });
    }

    onClickTMVoucherBackBtn() {
        this.props.setTmVoucherModelVisibility(false);
        const { selectedTMVoucher } = this.state;
        isEqual(selectedTMVoucher, {}) ? this.setState({ isShowTMVoucher: false, selectedTMVoucher: {} }) : this.setState({ isShowTMVoucher: false, selectedTMVoucher: {} });
    }

    onChangeSelectTaskCode(taskCode) {
        this.setState({ selectedTMVoucher: taskCode });
    }

    getTMVoucherTaskCodes() {
        let { weekStartDate, weekEndingDate } = this.state;
        let startTime = new Date(weekStartDate.setHours(0, 0, 0));
        let startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        let tomorrow = new Date(weekEndingDate);
        let endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        let endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        let dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        let timeZone = startDate.toString();
        let selectTimeZone = timeZone.slice(16, 24);
        let selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        let dateSelected = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);

        let url = `${ApiUrls.Routes.TM_VCHR_C}${ApiUrls.Routes.GT_TM_VCHR_PRJ_TK_LT_M}?fromDate=${selectDate}@${selectTimeZone}&&toDate=${dateSelected}@${selectTimeZone}&deviceId=${this.props.device.deviceId}&status=${Constants.NEW_STATUS}&isNotInProgress=true`;
        Api.Get(url, this).then((response) => {
            if (response.success) {
                if (response.data && response.data.length > 0) {
                    this.setState({ tmTaskCodeList: response.data })
                }
            } else {
                MessageBox(response.message, Constants.ERROR);
            }
        });
    }

  onClickSelectBtn() {
      const { selectedTMVoucher } = this.state;
      if (isEqual(selectedTMVoucher, {})) {
          MessageBox(Constants.PLEASE_SELECT_TASK_CODE, Constants.ERROR);
      } else {
          this.props.setTmVoucherModelVisibility(true);
          this.props.history.push("/TMVoucherPDFViewer", {selectedTMVoucher});
      }
  }

    async openAttestation(timeRecordId, timeCardStatus) {
        const { timeRecords } = this.state;
        const records = timeRecords.map(t => t.timecardData).flat();
        const selectedRecord = records.find(t => t.timeRecordID === timeRecordId);
        const attestationPDF = selectedRecord?.attachmentContent;
        const url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ATTST_BTMCRD_ID_M}?deviceId=${this.props.device.deviceId}&timeRecordId=${timeRecordId}`;
        const attestationDetails = await getAttestation(url, timeRecords, timeRecordId, this);
        const isSubmittedAttestation = timeCardStatus !== Constants.IN_PROGRESS || attestationPDF !== null;
        this.props.history.push("Attestation", { timeRecords, attestationDetails, attestationPDF, isSubmittedAttestation, isFromWeekTimeCard: true });
    }

    render() {
        const { timeRecords,
            selectedDate,
            issueNotesList,
            isIssueNotesModalVisible,
            isAttachmentModelVisible,
            selectedAttachment,
            weekEndingDate,
            weekStartDate,
            isShowPunchesModal,
            selectedPayrollNote,
            isShowPayrollNoteModal,
            isShowActualNoteModal,
            isShowExpectationNoteModal,
            selectedActualNote,
            isOpenActualNotes,
            selectedTimeCardPunches,
            selectedExpectationNote,
            isShowLoader,
            isShowTMVoucher,
            tmTaskCodeList,
            selectedTMVoucher,
            tmVoucherConfirmMessage,
            isAllowAttestation,
        } = this.state;
        return (
            <Fragment>
                <PreviousWeekTimeCardComponent
                    {...{
                        timeCard: {
                            isIssueNotesModalVisible,
                            selectedDate,
                            issueNotesList,
                            isAttachmentModelVisible,
                            selectedAttachment,
                            weekEndingDate,
                            weekStartDate,
                            timeRecords,
                            isShowPunchesModal,
                            isShowPayrollNoteModal,
                            selectedPayrollNote,
                            isShowActualNoteModal,
                            selectedActualNote,
                            isOpenActualNotes,
                            isShowExpectationNoteModal,
                            selectedTimeCardPunches,
                            selectedExpectationNote,
                            isShowLoader,
                            isShowTMVoucher,
                            tmTaskCodeList,
                            selectedTMVoucher,
                            tmVoucherConfirmMessage,
                            isAllowAttestation,
                        }
                    }}
                    getTimeCardIssue={this.getTimeCardIssue.bind(this)}
                    closeIssueNotes={this.closeIssueNotes.bind(this)}
                    openNotes={this.openNotes.bind(this)}
                    onClickBack={this.onClickBack.bind(this)}
                    openAttachmentViewer={this.openAttachmentViewer.bind(this)}
                    openOrClosePunchesModal={this.openOrClosePunchesModal.bind(this)}
                    openOrClosePayrollNoteModel={this.openOrClosePayrollNoteModel.bind(this)}
                    openOrCloseExpectationNoteModel={this.openOrCloseExpectationNoteModel.bind(this)}
                    closeAttachmentViewer={this.closeAttachmentViewer.bind(this)}
                    onClickActualNoteBack={this.onClickActualNoteBack.bind(this)}
                    onClickDailyDetails={this.onClickDailyDetails.bind(this)}
                    onClickTMVoucherBtn={this.onClickTMVoucherBtn.bind(this)}
                    onClickTMVoucherBackBtn={this.onClickTMVoucherBackBtn.bind(this)}
                    onChangeSelectTaskCode={this.onChangeSelectTaskCode.bind(this)}
                    onClickSelectBtn={this.onClickSelectBtn.bind(this)}
                    openAttestation={this.openAttestation.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device,
        tmVoucherReducer: state.tmVoucherReducer.selectedTMVouchers
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({}, actions), dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PreviousWeekTimeCard));

PreviousWeekTimeCard.displayName = 'PreviousWeekTimeCard';